var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-column-edit-item",on:{"click":_vm.handleClick}},[_c('link-table-cell-normal',{attrs:{"render-func":_vm.renderFunc,"scope-slot-func":_vm.scopeSlotFunc,"text":_vm.showRow[_vm.field],"data":_vm.scopeSlotData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }